import React, { useEffect, useRef, useState, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Autoplay, Navigation } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { pageStatusChange } from "../../redux/property/PropertySlice";
import PropertyDetailsModel from "./latestProperty/PropertyDetailsModel";
import { sortPropertiesWithImagesFirst } from "../../utils/propertyUtils";
import { toggleShortlistProperty, isPropertyShortlisted } from "../../utils/shortlistUtils";
import { setModelShow } from "../../redux/athentication/Athentication";
import "./RecommendedPropertiesNew.css";

/* Crisp Vector Icons matching Design System */
const BedIcon = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#b87a14" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 9v11" />
    <path d="M22 20v-7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7" />
    <path d="M2 15h20" />
    <path d="M6 11V7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4" />
  </svg>
);

const BathIcon = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#b87a14" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12h16a1 1 0 0 1 1 1v3a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-3a1 1 0 0 1 1-1Z" />
    <path d="M6 12V5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v2" />
    <path d="M5 19l-1.5 2" />
    <path d="M19 19l1.5 2" />
  </svg>
);

const AreaIcon = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#b87a14" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18" strokeDasharray="2 2" />
    <path d="M3 15h18" strokeDasharray="2 2" />
    <path d="M9 3v18" strokeDasharray="2 2" />
    <path d="M15 3v18" strokeDasharray="2 2" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-2.2 2.2a15.053 15.053 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.57 3.99c.07-.55-.38-1-1-1H4.11c-.59 0-1.07.46-1.1 1.05C2.66 12.89 11.1 21.34 20.05 21c.59-.03 1.05-.51 1.05-1.1v-3.52c0-.55-.45-1-1-.99l-.09-.01z"/>
  </svg>
);

const ChatIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    <circle cx="8.5" cy="12" r="0.75" fill="currentColor" />
    <circle cx="12" cy="12" r="0.75" fill="currentColor" />
    <circle cx="15.5" cy="12" r="0.75" fill="currentColor" />
  </svg>
);

const HeartIcon = ({ isFavorite }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill={isFavorite ? "#e11d48" : "none"} stroke={isFavorite ? "#e11d48" : "#1f2937"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

const MapPinIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/>
  </svg>
);

const CameraIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle cx="12" cy="13" r="4" />
  </svg>
);

const PrevArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const NextArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

// High-quality Fallback Recommended Properties matching Hyderabad's best properties
const FALLBACK_RECOMMENDED_PROPERTIES = [
  {
    propertyID: "rec-vessella-1",
    apartment: "Vessella Woods",
    category: "Sell",
    subCategory: "Villa",
    superCategory: "Residential",
    visiblePrice: "8.5 cr",
    locality: "Kondapur",
    city: "Hyderabad",
    noofBedrooms: 4,
    noofBathrooms: 5,
    carpetArea: "3950",
    carpetAreaMesurmentType: "sq.ft.",
    postUserPosition: "Dealer",
    DeskImg: [
      "https://res.cloudinary.com/dctspi0kc/image/upload/v1730457937/Property/DesktopImage/mi4lygyz6bf0l5zknnrg.webp",
      "https://res.cloudinary.com/dctspi0kc/image/upload/v1730457938/Property/DesktopImage/szuebwzcourykkyt35g0.webp",
    ],
    unicProperty: "This 4 BHK Villa is available for Sell in Vessella woods, one of the most prominent projects for Villa in Vessella woods is available for Sell in Kondapur, Hyderabad.",
  },
  {
    propertyID: "rec-meadows-2",
    apartment: "Vessella Meadows",
    category: "Sell",
    subCategory: "Villa",
    superCategory: "Residential",
    visiblePrice: "8.0 cr",
    locality: "Narsingi",
    city: "Hyderabad",
    noofBedrooms: 4,
    noofBathrooms: 5,
    carpetArea: "3800",
    carpetAreaMesurmentType: "sq.ft.",
    postUserPosition: "Dealer",
    DeskImg: [
      "https://res.cloudinary.com/dctspi0kc/image/upload/v1730458750/Property/DesktopImage/zrwkrgdryvwbzv2ug9lm.webp",
      "https://res.cloudinary.com/dctspi0kc/image/upload/v1730458751/Property/DesktopImage/uv5z2ljrjtwhc9tzbyse.webp",
    ],
    unicProperty: "This 4 BHK Villa is available for Sell in Vessella meadows, one of the most prominent luxury projects near financial district.",
  },
  {
    propertyID: "rec-bhooja-3",
    apartment: "MY HOME BHOOJA",
    category: "Sell",
    subCategory: "Flat/apartment",
    superCategory: "Residential",
    visiblePrice: "9.0 cr",
    locality: "Hitec City",
    city: "Hyderabad",
    noofBedrooms: 3,
    noofBathrooms: 4,
    carpetArea: "3400",
    carpetAreaMesurmentType: "sq.ft.",
    postUserPosition: "Dealer",
    DeskImg: [
      "https://res.cloudinary.com/dctspi0kc/image/upload/v1730458675/Property/DesktopImage/k5dxbixawbjumpalbhll.webp",
      "https://res.cloudinary.com/dctspi0kc/image/upload/v1730458677/Property/DesktopImage/c9xjtolwzu8jl2osnk1q.webp",
    ],
    unicProperty: "This 3 BHK Flat/apartment is available for Sell in MY HOME BHOOJA, Hyderabad's most iconic luxury high-rise gated community.",
  },
  {
    propertyID: "rec-aparna-4",
    apartment: "Aparna Serene Park",
    category: "Sell",
    subCategory: "Flat/apartment",
    superCategory: "Residential",
    visiblePrice: "2.3 cr",
    locality: "Kondapur",
    city: "Hyderabad",
    noofBedrooms: 3,
    noofBathrooms: 3,
    carpetArea: "1850",
    carpetAreaMesurmentType: "sq.ft.",
    postUserPosition: "Dealer",
    DeskImg: [
      "https://res.cloudinary.com/dctspi0kc/image/upload/v1730458274/Property/DesktopImage/u91d5pb7agltq9mxdvyg.webp",
      "https://res.cloudinary.com/dctspi0kc/image/upload/v1730458275/Property/DesktopImage/nag5gqc3kwxwxzs5dphe.webp",
    ],
    unicProperty: "This 3 BHK Flat/apartment is available for Sell in Aparna Serene Park, Kondapur, with modern clubhouse and landscaped gardens.",
  },
];

const RecommendedProperties = () => {
  const { isAuth, loginData } = useSelector((store) => store.Athentication);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [properties, setProperties] = useState([]);
  const [city] = useState("Hyderabad");
  const [modal, setModal] = useState(false);
  const [singleProperty, setSingleProperty] = useState(null);
  const [actionType, setActionType] = useState("contact");
  const [favorites, setFavorites] = useState({});

  const swiperRef = useRef(null);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const url = `${Baseurl}/api/v1/property/recommended/${city}`;
        const fetchProperty = await axios.get(url);
        if (isMounted && fetchProperty.data?.success === true) {
          const propertyList = fetchProperty.data.property || [];
          setProperties(sortPropertiesWithImagesFirst(propertyList));
        }
      } catch (error) {
        // Fallback is handled automatically in useMemo
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, [city]);

  const toggleClick = (e, property, type = "contact") => {
    if (e && e.preventDefault) e.preventDefault();
    setSingleProperty(property);
    setActionType(type || "contact");
    setModal(true);
  };

  const verifyLogin = () => {
    dispatch(setModelShow(true));
    toast.info("Please log in to contact dealer or view phone number.", {
      position: "top-center",
      autoClose: 2000,
      className: "custom_toast",
    });
  };

  const handleActionClick = (e, property, type = "contact") => {
    if (e && e.preventDefault) e.preventDefault();

    if (isAuth) {
      if (loginData && (loginData.creadits >= 1 || loginData.credits >= 1 || !loginData.hasOwnProperty("creadits"))) {
        toggleClick(e, property, type);
      } else {
        navigate("/dashboard");
        dispatch(pageStatusChange(9));
      }
    } else {
      verifyLogin();
    }
  };

  const handleFavoriteClick = (e, propId, propObj) => {
    e.preventDefault();
    e.stopPropagation();
    const targetProp = propObj || { _id: propId, propertyID: propId };
    const isAdded = toggleShortlistProperty(targetProp);
    setFavorites((prev) => ({ ...prev, [propId]: isAdded }));
    if (isAdded) {
      toast.success("Property saved to shortlist!", {
        position: "top-center",
        autoClose: 1500,
      });
    } else {
      toast.info("Removed from shortlist", {
        position: "top-center",
        autoClose: 1500,
      });
    }
  };

  const displayProperties = useMemo(() => {
    const list = properties && properties.length > 0 ? properties : FALLBACK_RECOMMENDED_PROPERTIES;
    // Filter out items with completely missing apartment name and empty price
    const validList = list.filter((p) => p && (p.apartment || p.visiblePrice || p.unicProperty));
    return validList.length > 0 ? validList : FALLBACK_RECOMMENDED_PROPERTIES;
  }, [properties]);

  useEffect(() => {
    const syncFavorites = () => {
      const newFavs = {};
      (displayProperties || []).forEach((p) => {
        const id = p.propertyID || p._id;
        if (id) {
          newFavs[id] = isPropertyShortlisted(p);
        }
      });
      setFavorites(newFavs);
    };
    syncFavorites();
    window.addEventListener("mgh_shortlist_updated", syncFavorites);
    return () => window.removeEventListener("mgh_shortlist_updated", syncFavorites);
  }, [displayProperties]);

  const getImageSrc = (property) => {
    if (!property) return "/assets/images/why_choose_villa.jpg";

    // 1. DeskImg
    if (Array.isArray(property.DeskImg) && property.DeskImg.length > 0 && property.DeskImg[0]) {
      return property.DeskImg[0];
    }
    if (typeof property.DeskImg === "string" && property.DeskImg.trim()) {
      return property.DeskImg;
    }

    // 2. photos
    if (Array.isArray(property.photos) && property.photos.length > 0 && property.photos[0]) {
      return property.photos[0];
    }
    if (typeof property.photos === "string" && property.photos.trim()) {
      return property.photos;
    }

    // 3. images
    if (Array.isArray(property.images) && property.images.length > 0 && property.images[0]) {
      return property.images[0];
    }
    if (typeof property.images === "string" && property.images.trim()) {
      return property.images;
    }

    // 4. mobileimage
    if (Array.isArray(property.mobileimage) && property.mobileimage.length > 0 && property.mobileimage[0]) {
      return property.mobileimage[0];
    }
    if (typeof property.mobileimage === "string" && property.mobileimage.trim()) {
      return property.mobileimage;
    }

    // 5. thumbnail / image / img
    if (property.thumbnail) return property.thumbnail;
    if (property.image) return property.image;
    if (property.img) return property.img;

    return "/assets/images/why_choose_villa.jpg";
  };

  const getPhotoCount = (property) => {
    const count =
      (property.DeskImg && property.DeskImg.length) ||
      (property.photos && property.photos.length) ||
      (property.images && property.images.length) ||
      1;
    return `${count} Photos`;
  };

  const getTransactionBadge = (property) => {
    const cat = property.category || "";
    const lower = cat.toLowerCase();
    if (lower === "sell" || lower === "sale") return "Buy";
    if (lower === "rent") return "Rent";
    if (lower === "lease") return "Lease";
    if (lower === "pg") return "PG";

    const desc = (property.unicProperty || "").toLowerCase();
    if (desc.includes("rent")) return "Rent";
    if (desc.includes("lease")) return "Lease";
    return "Buy";
  };

  const getTypeBadge = (property) => {
    if (property.subCategory && property.subCategory.trim()) {
      return property.subCategory;
    }
    if (property.superCategory && property.superCategory.trim()) {
      return property.superCategory;
    }
    const desc = (property.unicProperty || "").toLowerCase();
    if (desc.includes("villa")) return "Villa";
    if (desc.includes("flat") || desc.includes("apartment")) return "Flat/apartment";
    if (desc.includes("plot")) return "Plot";
    if (desc.includes("commercial")) return "Commercial";
    return "Residential";
  };

  const getLocationString = (property) => {
    const loc = property.locality || property.apartment || "";
    const city = property.city || property.state || "Hyderabad";
    if (loc && !loc.toLowerCase().includes(city.toLowerCase())) {
      return `${loc}, ${city}`;
    }
    return loc || city;
  };

  const getAreaString = (property) => {
    if (property.carpetArea && property.carpetArea !== "undefined" && property.carpetArea !== "") {
      return `${property.carpetArea} ${property.carpetAreaMesurmentType || "sq.ft."}`;
    }
    if (property.superbuildupArea && property.superbuildupArea !== "undefined" && property.superbuildupArea !== "") {
      return `${property.superbuildupArea} ${property.superbuildupAreaMesurmentType || "sq.ft."}`;
    }
    if (property.plotArea && property.plotArea !== "undefined" && property.plotArea !== "") {
      return `${property.plotArea} ${property.plotAreaMesurmentType || "sq.yd."}`;
    }
    if (property.unicProperty) {
      const match = property.unicProperty.match(/Carpet Area of\s*([\d\w\s\.]+?)(?:,|\.|\s|$)/i);
      if (match && match[1] && match[1].trim() !== "sq" && match[1].trim().length > 2) {
        return match[1].trim();
      }
      const match2 = property.unicProperty.match(/(\d[\d,]*\s*(?:sq\.?\s*ft\.?|sqft|sq\.?\s*yd\.?|sqyd))/i);
      if (match2 && match2[1]) {
        return match2[1].trim();
      }
    }
    return "- Area";
  };

  const formatPrice = (val, property) => {
    const raw = val || property?.visiblePrice || property?.expectedPrice || property?.monthlyRent || property?.price;
    if (!raw) return "Price on Request";
    const str = String(raw).trim();
    if (str.startsWith("₹") || str.toLowerCase().startsWith("rs")) return str;

    const num = Number(str.replace(/[^0-9.]/g, ""));
    if (!isNaN(num) && num > 0 && !str.toLowerCase().includes("cr") && !str.toLowerCase().includes("l")) {
      if (num >= 10000000) {
        return `₹ ${(num / 10000000).toFixed(2).replace(/\.00$/, "")} Cr`;
      } else if (num >= 100000) {
        return `₹ ${(num / 100000).toFixed(2).replace(/\.00$/, "")} L`;
      } else if (num >= 1000) {
        return `₹ ${num.toLocaleString("en-IN")}`;
      }
    }
    return `₹ ${str}`;
  };

  return (
    <section className="recom-section">
      <div className="recom-inner">
        {/* Section Header */}
        <div className="recom-header">
          <div className="recom-header-left">
            
            <h2 className="recom-title">
              <span className="recom-title-dark">Recommended </span>
              <span className="recom-title-gold">Properties</span>
            </h2>
            <p className="recom-desc">
              Curated especially for you. Discover top residential and commercial listings hand-picked for your lifestyle.
            </p>
          </div>

          {/* Swiper Slider Navigation Controls */}
          <div className="recom-nav-btns">
            <button
              type="button"
              className="recom-nav-btn"
              onClick={() => swiperRef.current?.slidePrev()}
              title="Previous"
            >
              <PrevArrowIcon />
            </button>
            <button
              type="button"
              className="recom-nav-btn"
              onClick={() => swiperRef.current?.slideNext()}
              title="Next"
            >
              <NextArrowIcon />
            </button>
          </div>
        </div>

        {/* Swiper Slider Container */}
        <div className="recom-swiper-wrap">
          <Swiper
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper;
            }}
            slidesPerView={4}
            spaceBetween={16}
            grabCursor={true}
            observer={true}
            observeParents={true}
            loop={displayProperties.length > 4}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1.35,
                spaceBetween: 10,
              },
              380: {
                slidesPerView: 1.42,
                spaceBetween: 10,
              },
              480: {
                slidesPerView: 1.5,
                spaceBetween: 12,
              },
              768: {
                slidesPerView: 2.2,
                spaceBetween: 14,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 16,
              },
            }}
            modules={[Autoplay, Navigation]}
            className="recom-swiper"
          >
            {displayProperties.map((property, index) => {
              const propId = property.propertyID || property._id || `recom-prop-${index}`;
              const propUrl = `/property-info/${property.apartment || property.propertyID || "property"}/${property.propertyID}`;

              return (
                <SwiperSlide key={propId}>
                  <article className="recom-card">
                    {/* Image Wrap */}
                    <div className="recom-img-wrap">
                      <Link to={propUrl} className="recom-img-link">
                        <img
                          src={getImageSrc(property)}
                          alt={property.apartment || "Property"}
                          className="recom-img"
                          loading="lazy"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/assets/images/why_choose_villa.jpg";
                          }}
                        />
                      </Link>

                      {/* Top-Left Category & Type Badges */}
                      <div className="recom-badges-left">
                        <span className="recom-badge-buy">
                          {getTransactionBadge(property)}
                        </span>
                        <span className="recom-badge-type">
                          {getTypeBadge(property)}
                        </span>
                      </div>

                      {/* Top-Right Favorite / Wishlist */}
                      <button
                        type="button"
                        className="recom-fav-btn"
                        onClick={(e) => handleFavoriteClick(e, propId, property)}
                        title="Add to Wishlist"
                      >
                        <HeartIcon isFavorite={!!favorites[propId]} />
                      </button>

                      {/* Bottom-Left Location Overlay */}
                      <div className="recom-location-badge">
                        <MapPinIcon />
                        <span>{getLocationString(property)}</span>
                      </div>

                      {/* Bottom-Right Photos Count Overlay */}
                      <div className="recom-photos-badge">
                        <CameraIcon />
                        <span>{getPhotoCount(property)}</span>
                      </div>
                    </div>

                    {/* Card Body */}
                    <div className="recom-card-body">
                      {/* Title */}
                      <Link to={propUrl} className="recom-card-title-link">
                        <h3 className="recom-card-title" title={property.apartment || "Featured Property"}>
                          {property.apartment || "Featured Property"}
                        </h3>
                      </Link>

                      {/* Price */}
                      <div className="recom-card-price">
                        {formatPrice(property.visiblePrice, property)}
                      </div>

                      {/* Description */}
                      <p className="recom-card-desc" title={property.unicProperty || ""}>
                        {property.unicProperty ||
                          `This ${property.noofBedrooms ? `${property.noofBedrooms} BHK ` : ""}${getTypeBadge(property)} is available for Sale in ${property.apartment || "Hyderabad"}.`}
                      </p>

                      {/* Specifications Row */}
                      <div className="recom-card-specs">
                        <div className="recom-spec-item" title="Bedrooms">
                          <span className="recom-spec-icon-wrap"><BedIcon /></span>
                          <span>{property.noofBedrooms ? `${property.noofBedrooms} BHK` : "- BHK"}</span>
                        </div>

                        <div className="recom-spec-item" title="Bathrooms">
                          <span className="recom-spec-icon-wrap"><BathIcon /></span>
                          <span>{property.noofBathrooms ? `${property.noofBathrooms} Bath` : "- Bath"}</span>
                        </div>

                        <div className="recom-spec-item" title="Carpet Area">
                          <span className="recom-spec-icon-wrap"><AreaIcon /></span>
                          <span>{getAreaString(property)}</span>
                        </div>
                      </div>

                      {/* Action Buttons Row */}
                      <div className="recom-card-actions">
                        <button
                          type="button"
                          className="recom-btn-phone"
                          onClick={(e) => handleActionClick(e, property, "phone")}
                        >
                          <PhoneIcon />
                          <span className="recom-btn-lbl-full">View Phone</span>
                          <span className="recom-btn-lbl-mob">Call</span>
                        </button>

                        <button
                          type="button"
                          className="recom-btn-contact"
                          onClick={(e) => handleActionClick(e, property, "contact")}
                        >
                          <ChatIcon />
                          <span className="recom-btn-lbl-full">Contact {property.postUserPosition || "Dealer"}</span>
                          <span className="recom-btn-lbl-mob">Contact</span>
                        </button>
                      </div>
                    </div>
                  </article>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>

      {/* Details & Contact Modal */}
      {modal && singleProperty && (
        <Modal
          isOpen={modal}
          toggle={() => setModal(!modal)}
          className="modalmainnew"
          centered
        >
          <div className="model-wrappernew">
            {/* ModalHeader omitted to prevent duplicate X button */}
            <ModalBody style={{ padding: 0 }}>
              <PropertyDetailsModel
                closePropdet={() => setModal(false)}
                propertyprop={singleProperty}
                actionType={actionType}
                changeView={() => {}}
              />
            </ModalBody>
          </div>
        </Modal>
      )}
    </section>
  );
};

export default RecommendedProperties;
